module.exports = __webpack_public_path__ + "img/arrow-up.a28bd4dd.svg";